<template>
	<div class="user-watches-patients">
		<navigation :user_uid="user_uid" @viewMode="setViewMode"/>
		<spinner v-if="loading"/>
		<patients-grid v-if="!loading && isGridMode" :user_uid="user_uid" :groups="groups"/>
		<patients-list v-if="!loading && isListMode" :user_uid="user_uid" :groups="groups" @deleteGroup="onDeleteGroup"/>
	</div>
</template>

<script>
import Navigation from './UserWatchesNavigation'
import PatientsGrid from './UserWatchesPatientsGrid'
import PatientsList from './UserWatchesPatientsList'
import ApiCollection from '@/classes/api/ApiCollection'
import GroupCollection from '@/classes/GroupCollection'
import PatientCollection from '@/classes/PatientCollection'
export default {
	components: {
		Navigation,
		PatientsGrid,
		PatientsList
	},
	props: [
		'user_uid'
	],
	data () {
		return {
			groups: new ApiCollection(),
			patients: new ApiCollection(),
			viewMode: 'list'
		}
	},
	computed: {
		loading () {
			return this.groups.loading || this.patients.loading
		},
		isGridMode () {
			return this.viewMode === 'grid'
		},
		isListMode () {
			return this.viewMode === 'list'
		}
	},
	methods: {
		getGroups () {
			this.groups.loading = true
			this.groups.data = []
			return this.$api.groups.patients.getAll(this, this.user_uid)
				.then(response => {
					this.$log.info('groups', 'groups.patients.getAll OK', response)()
					return response.body
				}).catch(error => {
					this.$log.error('groups', 'groups.patients.getAll ERROR', error)()
					this.groups.error = error
				}).finally(() => {
					this.groups.loading = false
				})
		},
		getPatients () {
			//return this.$store.getters.getWatches
			this.patients.loading = true
			this.patients.data = []
			return this.$api.patients.getAll(this, this.user_uid)
				.then(response => {
					this.$log.info('patients', 'patients.getAll OK', response)()
					return response.body.sort((a, b) => a.name.localeCompare(b.name))
				}).catch(error => {
					this.$log.error('patients', 'patients.getAll ERROR', error)()
					this.patients.error = error
				}).finally(() => {
					this.patients.loading = false
				})
		},
		getData () {
			Promise.all([this.getGroups(), this.getPatients()])
				.then(([groupsData, patientsData]) => {
					this.$log.info('groups + patients', 'getData() OK', groupsData, patientsData)()
					this.patients.data = new PatientCollection(patientsData)
					this.groups.data = new GroupCollection(groupsData, this.patients.data)
				}).catch(error => {
					this.$log.error('groups + patients', 'getData ERROR', error)()
				})
		},
		setViewMode (mode) {
			switch (mode) {
				case 'grid':
					this.viewMode = 'grid'
					break
				case 'list':
					this.viewMode = 'list'
					break
				default:
					this.viewMode = 'list'
			}
		},
		onDeleteGroup (group_id) {
			if (confirm('Delete?')) {
				this.$api.groups.patients.delete(this, this.user_uid, group_id)
					.then(response => {
						this.$log.info('group form', 'groups.patients.delete OK', response)()
					}).catch(error => {
						this.$log.error('group form', 'groups.patients.delete ERROR', error)()
					}).finally(() => {
						this.getData()
					})
			}
		}
	},
	beforeCreate () {
		this.$title('Patients')
	},
	created () {
		this.$parent.$on('reload', this.getData)
	},
	mounted () {
		this.getData()
	},
	beforeDestroy () {
		this.$parent.$off('reload', this.getData)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/watches/UserWatchesPatients.vue